export const JwtBackLoginMixin = {
  methods: {
    backLogin(event) {
      if (event.data.data == "backLogin") {
        this.$router.push({ path: "/login" }).catch((err) => err)
      }
    },
  },
}

export const publishCommitMixin = {
  methods: {
    async CommitPublish(publishList, datetime, category) {
      localStorage.setItem("lastTime", datetime)
      let xData = {}
      publishList.forEach((item, index) => {
        xData[`ids-${index}`] = item
      })
      xData["category"] = category
      xData["planned_published_time"] = datetime
      let self = this
      let bodyFormData = new FormData()
      for (let item in xData) {
        if (typeof xData[item] == "object") {
          bodyFormData.append(item, JSON.stringify(xData[item]))
        } else {
          bodyFormData.append(item, xData[item])
        }
      }
      try {
        const res = await self.axios({
          method: "post",
          headers: { "Content-Type": "multipart/form-data" },
          url: self.$store.state.baseurl + "api/meta/update",
          data: bodyFormData,
        })
        if (res.data.code == 0) {
          self.$Message.success("发布成功！")
        } else {
          self.$Message.error("操作失败，错误原因：" + res.data.error_message)
          // console.log(res)
        }
      } catch (err) {
        self.$Message.error("操作失败，错误原因：" + err)
        // console.log(err)
      }
    },
  },
}

export const idKindMixin = {
  methods: {
    //判断id类型
    checkIdKind(id) {
      if (id.indexOf("-") !== -1) {
        return "es_id"
      } else {
        return "id"
      }
    },
  },
}

export const downLoadMixin = {
  data() {
    return {
      urlList: {},
    }
  },
  methods: {
    async toDownLoad(row) {
      let self = this
      if (row["downUrl"] === "javascript:void(0)") {
        let xData = {
          source: row.source.substr(0, 1),
          resolution: 1080,
          video_id: row.video_id,
          item_id: row.source_item_id,
        }
        try {
          const res = await self.axios({
            method: "get",
            url: self.$store.state.baseurl + "api/video/url",
            params: xData,
          })
          if (!res) {
            return
          }
          if (res.data.code === 0) {
            let _data = []
            self.videoData.forEach((item) => {
              if (item.id === row.id) {
                self.$set(item, "downUrl", res.data.data.url)
              }
              _data.push(item)
            })
            self.videoData = []
            self.videoData.push(..._data)
          } else {
            self.$Message.error("操作失败，错误原因：" + res.data.error_message)
            // console.log(res)
          }
        } catch (err) {
          self.$Message.error("操作失败，错误原因：" + err)
          // console.log(err)
        }
      } else {
        let input = document.createElement("input") // 直接构建input
        input.value = row["downUrl"] // 设置内容
        document.body.appendChild(input) // 添加临时实例
        input.select() // 选择实例内容
        document.execCommand("Copy") // 执行复制
        document.body.removeChild(input) // 删除临时实例
        this.$Message.success("复制成功")
      }
    },
  },
}

export const KeFuMixin = {
  data() {
    return {}
  },
  methods: {
    getDevice() {
      const ua = navigator.userAgent.toLowerCase()
      window.console.log(ua)
      let isMobile = false
      let isMiniPro = false
      let mobile = ""
      if (ua.match(/android|iPhone|iPad/i)) {
        isMobile = true
        mobile = ua.match(/android|iPhone|iPad/i)[0]
        if (ua.match(/MicroMessenger/gi)) {
          isMiniPro = true
        } else if (ua.match(/swan-baiduboxapp/gi)) {
          isMiniPro = true
        }
      }
      return {
        isMobile,
        isMiniPro,
        mobile,
      }
    },
    setCookie(name, value, expires, path, domain, secure) {
      // expires以天为单位
      // eslint-disable-next-line prefer-const
      let today = new Date()
      today.setTime(today.getTime())
      if (expires) {
        expires *= 86400000
      }
      const expiresDate = new Date(today.getTime() + expires)
      document.cookie =
        name +
        "=" +
        escape(value) +
        (expires ? ";expires=" + expiresDate.toGMTString() : "") +
        (path ? ";path=" + path : "") +
        (domain ? ";domain=" + domain : "") +
        (secure ? ";secure" : "")
    },
    getCookie(name) {
      const reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)")
      const result = document.cookie.match(reg)
      if (result) {
        return unescape(result[2])
      } else {
        return null
      }
    },
  },
}

export const checkUserMixin = {
  data() {
    return {
      checkUserText: "",
      checkColor: "",
    }
  },
  methods: {
    async checkUser() {
      if (this.user.length > 0) {
        try {
          const res = await this.axios({
            method: "get",
            url: this.$store.state.baseurl + "api/user/get",
            params: {
              id: this.user,
            },
          })
          if (res.data.code == 0) {
            this.checkColor = ""
            this.checkUserText = "名字：" + res.data.data.name + "<br/>"
            this.checkUserText = this.checkUserText + "手机：" + res.data.data.mobile + "<br/>"
            this.checkUserText = this.checkUserText + "角色：" + res.data.data.roles
          } else {
            this.checkUserText = "user id验证失败！"
            this.checkColor = "#f44336"
          }
        } catch (err) {
          this.$Message.error("操作失败，错误原因：" + err)
        }
      } else {
        this.checkUserText = ""
        this.checkColor = ""
      }
    },
  },
}
